import { API_PATHS } from "../constants/api-paths";
import { createCacheAsync } from "@repo/shared-utils/cache";
import { IResponse, encryptedRequest } from "../core/api.client";

export interface IApiResponseCardRead {
  id: string;
  journeyName: string;
  segmentId: string;
  partnerBank: string;
  offerSelectedByCustomer: string;
  cardCode: string;
  saveForLaterFlag: string;
  cibiliStatus: string;
  pricingCode: string;
  eventCode: string;
}

// Stub: ICCSegment fields are fully typed – update when API schema is confirmed.
export interface ICCSegment {
  fees: string;
  cardCode: string;
  pricingCode: string;
  cardType: string;
  logo: string;
  blockCode: string;
  firstYearFees: string;
  subsequentYearFeeWaived: string;
  subsequentYearFee: string;
  annualFee: string;
  priority: string;
}
export interface IApiResponseSegmentMaster {
  segmentMasterDetails: ICCSegment[];
}

export interface IApiResponseCardInsert {
  applicationID: string;
  customerNameNsdl: string;
  oglStatus: string;
}

export const getCard = async (
  mobileNo: string,
  id: string
): Promise<IResponse<IApiResponseCardRead>> => {
  const response = await createCacheAsync(
    `${API_PATHS.ccRead}-${id}-${mobileNo}}`,
    encryptedRequest<IApiResponseCardRead>,
    {
      method: "POST",
      url: API_PATHS.ccRead,
      data: { mobileNo, id },
    }
  );

  return response;
};

export const getSegment = async (
  segmentId: string
): Promise<IResponse<IApiResponseSegmentMaster>> => {
  const response = await createCacheAsync(
    `${API_PATHS.ccSegmentMaster}-${segmentId}`,
    encryptedRequest<IApiResponseSegmentMaster>,
    {
      method: "POST",
      url: API_PATHS.ccSegmentMaster,
      data: { segmentId },
    }
  );
  return response;
};

export const insertCard = async (data: {
  journeyName: string;
  offerId: string;
  offerSelectedByCustomer: string;
  pinCode: string;
  segmentId: string;
  segmentData: Record<string, unknown>;
  pricingCode: string;
  mobileNo: string;
  custType: string;
  partnerBank: string;
  cardCode: string;
}): Promise<IResponse<IApiResponseCardInsert>> => {
  const response = await encryptedRequest<IApiResponseCardInsert>({
    method: "POST",
    url: API_PATHS.ccInsertCard,
    data,
  });
  return response;
};
